<template>
	<Modal :visible="visible" class="availability-dates-modal" @toggle="$emit('toggle', !!$event)">
		<template #content>
			<AvailabilityDates @close="$emit('toggle', !!$event)"/>
		</template>
	</Modal>
</template>

<script>
import AvailabilityDates from '@/components/availability/AvailabilityDates';

export default {
	name: 'AvailabilityDatesModal',
	components: {
		AvailabilityDates,
	},
	model: {
		prop: 'visible',
		event: 'toggle',
	},
	props: {
		visible: {
			type: Boolean,
			default: null,
		},
	},
};
</script>
